import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, Button, Row, Col, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import FormContainer from "../components/FormContainer";

import {
  useLoginMutation,
  useForgotPasswordMutation,
} from "../slices/usersApiSlice";
import { setCredentials } from "../slices/authSlice";
import { toast } from "react-toastify";

const LoginScreen = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [login, { isLoading }] = useLoginMutation();
  const [forgotPassword, { isLoading: isLoadingForgot }] =
    useForgotPasswordMutation();

  const { userInfo } = useSelector((state) => state.auth);

  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const redirect = sp.get("redirect") || "/";

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [navigate, redirect, userInfo]);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const res = await login({ email, password }).unwrap();
      dispatch(setCredentials({ ...res }));
      navigate(redirect);
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const forgotPasswordHandler = async () => {
    if (!email) {
      toast.error("אנא הכנס כתובת מייל");
      return;
    }

    try {
      await forgotPassword({ email }).unwrap();
      setShowModal(true);
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <FormContainer>
      <h1 className="text-end">כניסה</h1>

      <Form onSubmit={submitHandler}>
        <Form.Group className="my-2" controlId="email">
          <Row>
            <Col xs={12} className="text-end">
              <Form.Label>כתובת מייל</Form.Label>
            </Col>
            <Col xs={12}>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></Form.Control>
            </Col>
          </Row>
        </Form.Group>

        <Form.Group className="my-2" controlId="password">
          <Row>
            <Col xs={12} className="text-end">
              <Form.Label>סיסמא</Form.Label>
            </Col>
            <Col xs={12}>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></Form.Control>
            </Col>
          </Row>
        </Form.Group>

        <Row className="my-2">
          <Col className="d-flex justify-content-between align-items-center">
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                forgotPasswordHandler();
              }}
              style={{
                fontSize: "1rem",
                textDecoration: "none",
                color: isLoadingForgot ? "#6c757d" : "#0d6efd",
                pointerEvents: isLoadingForgot ? "none" : "auto",
              }}
            >
              {isLoadingForgot ? "שולח..." : "שכחתי סיסמא"}
            </Link>
            <Button disabled={isLoading} type="submit" variant="primary">
              כניסה
            </Button>
          </Col>
        </Row>

        {isLoading && <Loader />}
      </Form>

      <Row className="py-3">
        <Col className="text-end">
          לקוח חדש?{" "}
          <Link to={redirect ? `/register?redirect=${redirect}` : "/register"}>
            הירשם
          </Link>
        </Col>
      </Row>

      {/* Forgot Password Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-end w-100">סיסמא נשלחה</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-end">
          <p>הסיסמא נשלחה לכתובת המייל:</p>
          <p>
            <strong>{email}</strong>
          </p>
          <p>אנא בדוק את תיבת הדואר הנכנס שלך.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowModal(false)}>
            אישור
          </Button>
        </Modal.Footer>
      </Modal>
    </FormContainer>
  );
};

export default LoginScreen;
